class StoreUtils {
	store: Object;
}

export default new StoreUtils();
